import { useQueryClient } from '@tanstack/react-query';

import { LoadingButton, useToaster, withConfirmation } from '@crossnokaye/ux-common';

import { useAuthUser } from '@/providers';

import { useRevokeAllTokens } from '../../hooks/useRevokeAllTokens';
const ButtonWithConfirmation = withConfirmation(LoadingButton);

export const RevokeAllAction = ({ ...props }) => {
  const { user } = useAuthUser();
  const queryClient = useQueryClient();
  const { addSuccessToast, addErrorToast } = useToaster();

  const { mutate: revokeAllTokens, isPending } = useRevokeAllTokens({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['iam', 'ListUserRefreshTokens'] });
      addSuccessToast('All tokens have been revoked.');
    },
    onError: () => {
      addErrorToast('Failed to revoke all tokens.');
    },
  });

  const handleRevokeAll = () => {
    revokeAllTokens({ userId: user.id });
  };

  return (
    <ButtonWithConfirmation
      variant={'destructive'}
      size={'lg'}
      isLoading={isPending}
      disabled={isPending}
      confirmationTitle={'Revoke All Tokens'}
      confirmationDescription={'Are you sure you want to revoke all tokens?'}
      confirmLabel={'Revoke'}
      cancelLabel={'Cancel'}
      type={'button'}
      onConfirm={handleRevokeAll}
      {...props}
    >
      {'Revoke All'}
    </ButtonWithConfirmation>
  );
};
